import styles from "./file-item.module.scss";

import {ReactComponent as Upload} from "../assets/upload.svg";
import {ReactComponent as Download} from "../assets/download.svg";

import icons from "./icons";

const FileItem = ({url, type, filename, created}) => {
    const [date] = created.split("T");

    return (
        <div className={styles.document}>
            <div className={styles.docIcon}>
                {icons[type]}
            </div>
            <div className={styles.docInfo}>
                <h5 className={styles.docTitle}>{filename}</h5>
                <div className={styles.docData}>
                    <span>1,2MB</span>
                    <span className={styles.docDataDivider}></span>
                    <span>{date}</span>
                </div>
            </div>
            <div className={styles.upload}>
                    {/*<span style={{marginRight: "16px"}}>*/}
                    {/*    <Upload/>*/}
                    {/*</span>*/}
                <a href={url} target="_blank"><Download /></a>
            </div>
        </div>
    )
}

export default FileItem;
